import { GatewayQuestionnaire } from "@conformite/gateway";
import { userSession } from "@src/data/session/UserSession";

export class QuestionnaireApi {
  static async getDefinitions() {
    const { data } = await userSession.axiosInstance.get<
      GatewayQuestionnaire.QuestionnaireDefinitionResponse[]
    >("/admin/questionnaires");
    return data;
  }

  static async getDefinition(slug: string) {
    const { data } =
      await userSession.axiosInstance.get<GatewayQuestionnaire.QuestionnaireDefinitionResponse>(
        `/admin/questionnaires/${slug}`
      );
    return data;
  }

  static async createDefinition(
    body: GatewayQuestionnaire.CreateQuestionnaireDefinitionRequestType
  ) {
    const { data } =
      await userSession.axiosInstance.post<GatewayQuestionnaire.QuestionnaireDefinitionResponse>(
        "/admin/questionnaires",
        body
      );
    return data;
  }

  static async updateDefinition(
    id: string,
    body: GatewayQuestionnaire.UpdateQuestionnaireDefinitionRequestType
  ) {
    const { data } =
      await userSession.axiosInstance.put<GatewayQuestionnaire.QuestionnaireDefinitionResponse>(
        `/admin/questionnaires/${id}`,
        body
      );
    return data;
  }

  static async deleteDefinition(id: string) {
    await userSession.axiosInstance.delete(`/admin/questionnaires/${id}`);
  }

  static async getInstances(contextType: string, contextId: string) {
    const { data } = await userSession.axiosInstance.get<
      GatewayQuestionnaire.QuestionnaireInstanceResponse[]
    >(`/admin/questionnaires/instances/${contextType}/${contextId}`);
    return data;
  }

  static async getLatestInstance(
    contextType: string,
    contextId: string,
    questionnaireSlug?: string
  ) {
    const params = questionnaireSlug ? { questionnaireSlug } : undefined;
    const { data } =
      await userSession.axiosInstance.get<GatewayQuestionnaire.QuestionnaireInstanceResponse | null>(
        `/admin/questionnaires/instances/${contextType}/${contextId}/latest`,
        { params }
      );
    return data;
  }

  static async getLatestInstances(
    body: GatewayQuestionnaire.GetLatestInstancesRequestType
  ) {
    const { data } = await userSession.axiosInstance.post<
      GatewayQuestionnaire.QuestionnaireInstanceResponse[]
    >("/admin/questionnaires/instances/latest", body);
    return data;
  }

  static async saveInstance(
    body: GatewayQuestionnaire.SaveQuestionnaireInstanceRequestType
  ) {
    const { data } =
      await userSession.axiosInstance.post<GatewayQuestionnaire.QuestionnaireInstanceResponse>(
        "/admin/questionnaires/instances",
        body
      );
    return data;
  }
}
